import {sessionStore} from "../utils/sessionStore";

export function putMemberRetailersInShittyCookie(retailers) {
    if (null === retailers || retailers === undefined) {
        sessionStore.set('retailers', null);
        return;
    }

    if (!Array.isArray(retailers)) {
        console.error('retailers given is not array or null');
        return;
    }

    sessionStore.set('retailers', retailers);
}

export function getMemberRetailers() {
    return sessionStore.get('retailers');
}